import { render, staticRenderFns } from "./postView.vue?vue&type=template&id=1606e6be&scoped=true&"
import script from "./postView.vue?vue&type=script&lang=js&"
export * from "./postView.vue?vue&type=script&lang=js&"
import style0 from "./postView.vue?vue&type=style&index=0&id=1606e6be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606e6be",
  null
  
)

export default component.exports